import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f9f390c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search el-input__icon fas" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Historico", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_page_header_component = _resolveComponent("page-header-component")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_HistoricStationTable = _resolveComponent("HistoricStationTable")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      class: _normalizeClass(_ctx.$attrs.class)
    }, {
      header: _withCtx(() => [
        _createVNode(_component_page_header_component, {
          title: _ctx.$t('label.samplingPointList')
        }, {
          right: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.value1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value1) = $event)),
              placeholder: "Filtrar",
              style: {"width":"240px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.entities,
          stripe: "",
          "row-class-name": _ctx.tableRowClassName,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "camera.code",
              label: _ctx.$t('label.camera'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.camera ? scope.row.camera.code : "-"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "lastEstimation",
              label: _ctx.$t('label.lastEstimation'),
              align: "center",
              "header-align": "center",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.lastEstimation ? scope.row.lastEstimation : "-"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "container.name",
              label: _ctx.$t('label.losses'),
              align: "center",
              "header-align": "center",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.container.name ? scope.row.container.name : "-"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: _ctx.$t('label.estimations'),
              align: "center",
              "header-align": "center",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.type ? scope.row.type : "-"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, null, {
              header: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "search",
                  modelValue: _ctx.query,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event)),
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search())),
                  width: "30%",
                  placeholder: _ctx.$t('placeholder.searchPoint')
                }, {
                  prefix: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openHistoricTableDialog()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "row-class-name"]),
        _createVNode(_component_el_pagination, {
          class: "app-table",
          layout: "total, sizes, prev, pager, next, jumper",
          currentPage: _ctx.currentPage,
          "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentPage) = $event)),
          "page-sizes": [10, 20, 50, 100],
          "page-size": _ctx.rowPerPage,
          total: _ctx.totalRows,
          onSizeChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePaginationSize($event))),
          onCurrentChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePaginationPage($event)))
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showHistoricTable,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showHistoricTable) = $event)),
      "destroy-on-close": "",
      width: "55%",
      "custom-class": "app-form",
      title: "Registro histórico"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_HistoricStationTable, { ref: "form" }, null, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}